// extracted by mini-css-extract-plugin
module.exports = {"withdrawHeader":"styles_withdrawHeader__393Yb","withdrawContent":"styles_withdrawContent__3l_SE","withdrawButton":"styles_withdrawButton__2lx_z"};